var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEdit
    ? _c("div", { staticClass: "contact-info-view" }, [
        (_vm.currentWorkPermit.contactList || []).length
          ? _c("table", { staticClass: "contact-view-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c(
                      "label",
                      { staticClass: "basic-info-title contact-label-name" },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("workPermit.contactInfo.contactPerson"))
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _c(
                      "label",
                      { staticClass: "basic-info-title contact-label-mobile" },
                      [_vm._v(_vm._s(_vm.$t("workPermit.contactInfo.mobile")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _c(
                      "label",
                      { staticClass: "basic-info-title contact-label-tel" },
                      [_vm._v(_vm._s(_vm.$t("workPermit.contactInfo.tel")))]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.contactList, function (item, index) {
                  return _c("tr", { key: "display-contact-info-" + index }, [
                    _c("td", { staticClass: "content-name" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.displayI18nFullName(
                              item.firstName,
                              item.lastName
                            ) || _vm.$t("emptyValue")
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(item.phone || _vm.$t("emptyValue"))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(item.tel || _vm.$t("emptyValue"))),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ])
    : _c(
        "div",
        { staticClass: "contact-info-edit" },
        [
          _vm._l(_vm.contactList, function (item, index) {
            return _c(
              "div",
              { key: "contact-list-edit-" + index, staticClass: "content row" },
              [
                _c("div", { staticClass: "contact-info-input small-4" }, [
                  index === 0
                    ? _c(
                        "label",
                        { staticClass: "contact-label-name required-flag" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("workPermit.contactInfo.contactPerson")
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "generalInfo_contact-name name" },
                    _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                      return _c("HKLInput", {
                        directives: [
                          {
                            name: "fusioninputcheck",
                            rawName: "v-fusioninputcheck",
                            value: { type: "string" },
                            expression: "{type: 'string'}",
                          },
                        ],
                        key: "contact-name-" + index + "_" + fullnameObj.key,
                        staticClass: "small-6 columns",
                        attrs: {
                          placeholder: _vm.$t(
                            "contact.basic." + fullnameObj.label
                          ),
                          value: item["" + fullnameObj.label],
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateContact(
                              $event.target.value,
                              fullnameObj.label,
                              index
                            )
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contact-info-input phone small-3 columns" },
                  [
                    index === 0
                      ? _c(
                          "label",
                          { staticClass: "contact-label-mobile required-flag" },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("workPermit.contactInfo.mobile")
                                ) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mobile" },
                      [
                        _c("HKLInput", {
                          directives: [
                            {
                              name: "fusioninputcheck",
                              rawName: "v-fusioninputcheck",
                              value: { type: "string" },
                              expression: "{type: 'string'}",
                            },
                          ],
                          staticClass: "generalInfo_contact-phone",
                          attrs: { value: item.phone },
                          on: {
                            input: function ($event) {
                              return _vm.updateContact(
                                $event.target.value,
                                "phone",
                                index
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contact-info-input small-3 columns" },
                  [
                    index === 0
                      ? _c("label", { staticClass: "contact-label-tel" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("workPermit.contactInfo.tel")) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tel-with-delete" },
                      [
                        _c("HKLInput", {
                          staticClass: "generalInfo_contact-tel",
                          attrs: { value: item.tel },
                          on: {
                            input: function ($event) {
                              return _vm.updateContact(
                                $event.target.value,
                                "tel",
                                index
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.contactList.length > 1
                          ? _c("i", {
                              staticClass: "fa-times fa small-1 columns",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteAccount(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("HKLButton", {
            staticClass: "add-account",
            attrs: { id: "addColumnsBtn", action: "addContractorPerson" },
            on: { click: _vm.addAccount },
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }